import { render, staticRenderFns } from "./TCS.vue?vue&type=template&id=2e36805f"
import script from "./TCS.vue?vue&type=script&lang=js"
export * from "./TCS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports